// English strings (source language): Club screen (teams, kit, roster).

const en = {
  title: 'Club',
  intro: 'Ride under one name: a club, its kit and its members.',
  offline: 'Server unreachable: clubs need the Gruvetto server.',
  noClub: 'You are not in a club yet.',
  noClubHelp: 'Join one with the code a friend gave you, find an open club, or create yours.',
  joinTitle: 'Join a club',
  codePlaceholder: 'Club code',
  join: 'Join',
  joined: (name: string) => `Welcome to ${name}!`,
  findTitle: 'Find a club',
  searchPlaceholder: 'Club name or tag',
  search: 'Search',
  noResult: 'No club found.',
  open: 'Open club',
  inviteOnly: 'By invitation',
  memberCount: (n: number) => `${n} member${n === 1 ? '' : 's'}`,
  createTitle: 'Create a club',
  create: 'Create the club',
  created: (name: string) => `${name} is born. Share the code to recruit!`,
  name: 'Club name',
  namePlaceholder: 'The Climbers',
  tag: 'Tag',
  tagHelp: '2 to 4 letters, shown next to the members’ names.',
  description: 'Description',
  descriptionPlaceholder: 'Who you are, when you ride…',
  visibility: 'Who can join',
  visibilities: { open: 'Anyone, from the search', invite: 'Only with the code' },
  kit: 'Club kit',
  kitHelp: 'The outfit every member can wear: a jersey, and if you like a helmet, a frame and wheels. Each piece is an outfit from the store or the workshop.',
  quickKit: 'Quick kit',
  quickKitHelp: 'A pattern and two colours become a jersey creation of yours: the club wears it, and you can rework it in the workshop later.',
  makeKit: 'Make it the club jersey',
  piecesHelp: 'A piece is a published outfit of your collection: yours, a free one, or one you bought. Publish a draft from the workshop to use it here.',
  pieceBy: (name: string) => `by ${name}`,
  noPiece: 'Official piece of each rider',
  choosePiece: 'Choose',
  changePiece: 'Change',
  removePiece: 'Take this piece out of the kit',
  pickTitle: (slot: string) => `Club ${slot}`,
  pickHelp: 'The published outfits of your collection for this slot: yours, published from the workshop, and community ones added or bought in the store. Official outfits cannot be club pieces. The whole club will wear the one you pick.',
  usePiece: 'Use it',
  inKit: 'In the kit',
  unpublished: 'Draft: publish it first',
  noCandidate: 'No published outfit for this slot yet',
  noCandidateHelp: 'Official outfits of the store do not count here. Add a community outfit from the store, or create one in the workshop and publish it, then come back.',
  findOutfits: 'Community outfits',
  kitSaved: 'Kit updated: members wearing it get the new piece',
  pattern: 'Pattern',
  patterns: { plain: 'Plain', gradient: 'Gradient', stripes: 'Stripes', dots: 'Dots', checker: 'Checker', chevrons: 'Chevrons', band: 'Band' },
  color: 'Main colour',
  accent: 'Second colour',
  tagOnChest: 'Print the tag on the chest',
  preview: 'Preview',
  save: 'Save',
  saved: 'Club saved',
  edit: 'Edit the club',
  cancel: 'Cancel',
  wear: 'Wear the kit',
  wearHelp: 'Puts every piece of the club kit on your rider and takes the club colour as your team colour.',
  wearing: 'You wear the club kit',
  takeOff: 'Take it off',
  wornToast: 'Club kit on. See you on the start line!',
  takenOff: 'Club kit off',
  roster: 'Members',
  roles: { owner: 'Owner', captain: 'Captain', member: 'Member' },
  since: (when: string) => `since ${when}`,
  lastRide: (when: string) => `last ride ${when}`,
  noRide: 'no rides',
  makeCaptain: 'Make captain',
  makeMember: 'Back to member',
  handOver: 'Hand over the club',
  handOverAsk: (name: string) => `Hand the club over to ${name}? You become a captain.`,
  handOverBtn: 'Hand over',
  handedOver: (name: string) => `${name} now owns the club`,
  remove: (name: string) => `Remove ${name}`,
  removeAsk: (name: string) => `Remove ${name} from the club?`,
  removeBtn: 'Remove',
  removed: (name: string) => `${name} removed from the club`,
  roleChanged: 'Role updated',
  feed: 'Latest rides of the club',
  feedEmpty: 'No ride yet. Be the first!',
  codeTitle: 'Invitation code',
  codeHelp: 'Give this code to a rider, or send the link: they just open it and join.',
  copyCode: 'Copy code',
  copyLink: 'Copy invite link',
  renewCode: 'New code',
  renewed: 'New code: the old link no longer works',
  copied: (what: string) => `${what} copied`,
  code: 'Code',
  link: 'Link',
  leave: 'Leave the club',
  leaveAsk: (name: string) => `Leave ${name}? The club kit comes off your rider.`,
  leaveOwnerAsk: (name: string) => `You are the only member: leaving disbands ${name}.`,
  leaveBtn: 'Leave',
  left: 'You left the club',
  disband: 'Disband the club',
  disbandAsk: (name: string) => `Disband ${name}? Every member leaves and the kit disappears. This cannot be undone.`,
  disbandBtn: 'Disband',
  disbanded: 'Club disbanded',
  inviteTitle: 'Club invitation',
  inviteText: (name: string) => `You are invited to join ${name}.`,
  inviteUnknown: 'This invitation is no longer valid: ask for a new code.',
  alreadyIn: 'You already belong to a club: leave it first.',
  clubBoard: 'Club leaderboard',
  ranking: 'Top clubs',
  rankingHelp: 'Clubs ranked by the XP of their members.',
  rankingEmpty: 'No club ranked yet. Create the first one!',
  xp: 'XP',
  view: 'View',
  back: 'Back to my club',
  clubPage: 'Club page',
  owner: (name: string) => `Run by ${name}`,
};
export default en;
